import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { InteractionEvent } from '@tencent/alloy-renderer';
import { enumerateGroup } from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';
import {
    InterfaceFactoryOptions,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import {
    TDWActionType, TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

export class PcMobileCommonLogic {
    private needMouseUp: boolean;
    public constructor(private factoryOptions: InterfaceFactoryOptions<IElementBaseModel>) {

    }

    public findRootGroupMouseDown = (e: InteractionEvent, leafModel: IElementBaseModel) => {
        enumerateGroup(leafModel, (groupModel: IGroupModel) => {
            if (groupModel.isRootGroup) {
                this.handleMouseDownPresenter(e, leafModel, groupModel);
            }
        });
    };

    public findRootGroupMouseUp = (e: InteractionEvent, leafModel: any) => {
        enumerateGroup(leafModel, (groupModel: IGroupModel) => {
            if (groupModel.isRootGroup) {
                this.handleMouseUpPresenter(e, leafModel);
            }
        });
    };

    private updateSelectedElement = (e, childModel: IElementBaseModel) => {
        if (this.factoryOptions.selectionService?.selectedElements
            .selectedArrayForType(SelectedEleMgrType.GROUP).length === 0) {
            // 当未选中组合子元素时，区分两种情况：1.选中子元素 2.仅点击到子元素上，但行为是拖拽组合
            // 情况1.needMouseUp为true，会添加选中；情况2.拖拽时修改needMouseUp为false，不添加选中
            this.needMouseUp = true;
            e.stopPropagation(); // 会影响组合
        } else {
            e.stopPropagation();
            // shift/control/command按住时多选
            if (e.nativeEvent.metaKey || e.nativeEvent.shiftKey || e.nativeEvent.ctrlKey) {
                if (childModel.selected) {
                    this.needMouseUp = true;
                } else {
                    this.factoryOptions.selectionService?.selectedElements.add(childModel);
                    this.reportOnSelect(childModel);
                }
            } else if (!childModel.selected) {
                this.factoryOptions.selectionService?.selectedElements.clear(SelectedEleMgrType.GROUP);
                this.factoryOptions.selectionService?.selectedElements.add(childModel);
                this.reportOnSelect(childModel);
                this.factoryOptions.editingStateManager?.updateElementCropState(false);
            }
        }

        // 只有 pc 端需要走这个逻辑来拖拽组合中的子元素，移动端对应的逻辑在 edit-mobile/common-edit-logic 中
        if (browser.isPc && childModel.type !== UIModelType.TABLE
            && this.getAppServices().viewableServiceLayer.userPriviledgeService.isEditable()) {
            (this.getAppServices() as IEditorAppServices)
                .editableServiceLayer?.dragElementHandler.handleMouseDownOnElement(
                    e, childModel,
                    this.factoryOptions.getPageScale(), this.needMouseUp, () => {
                        this.needMouseUp = false;
                    },
                );
        }
    };

    private handleMouseDownPresenter = (e, childModel: IElementBaseModel, rootGroup: IGroupModel) => {
        if (this.getAppServices().getEntryType() === AppEntryType.PC_EDIT) {
            (this.getAppServices() as IPcEditorAppServices).editableServiceLayer?.selectedAnims?.clear();
        }
        // group 嵌套往上传递
        if (rootGroup.selected
            && this.factoryOptions.selectionService?.selectedElements
                .selectedArrayForType(SelectedEleMgrType.SLIDE).length === 1) {
            // tdw 上报逻辑
            this.tdwHandleMouseDown(childModel);
            this.updateSelectedElement(e, childModel);
        }
    };

    private handleMouseUpPresenter = (e, childModel: IElementBaseModel) => {
        if (this.needMouseUp) {
            if (!childModel.selected) {
                this.factoryOptions.selectionService?.selectedElements.add(childModel);
            } else {
                this.factoryOptions.selectionService?.selectedElements.remove(childModel);
            }
            this.reportOnSelect(childModel);
            this.needMouseUp = false;
        }
    };


    /**
     * 选中元素后上报
     * @param model
     */
    private reportOnSelect = (model: IElementBaseModel) => {
        if (this.factoryOptions.model.currentEditState !== PPTEditorStateType.EDITABLE) return;
        let action = '';
        if (model.type === UIModelType.SHAPE) {
            action = TDWActionType.CLK_EDIT;
        }
        if (model.type === UIModelType.IMAGE) {
            action = TDWActionType.CLK_IMG;
        }
        if (model.type === UIModelType.GROUP) {
            action = TDWActionType.CLK_COMBIN;
        }
        if (action) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_OBJ,
                action,
            });
        }
    };

    private tdwHandleMouseDown = (childModel: IElementBaseModel) => {
        let action: null | string = null;
        switch (childModel.type) {
            case UIModelType.SHAPE:
                action = (childModel as IShapeModel).subType === 1 ? TDWActionType.EDIT_TEXT : TDWActionType.EDIT_SHAPE;
                break;
            case UIModelType.IMAGE:
                action = TDWActionType.EDIT_IMG;
                break;
            case UIModelType.TABLE:
                action = TDWActionType.EDIT_FORM;
                break;

            default:
                break;
        }
        if (action) {
            // console.log('water group action = ',action);
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_OBJ,
                action,
            });
        }
    };

    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
    }
}
